import makeBehaviorSubject from 'callbag-behavior-subject';
import {ApiService} from '../api';
import {IdealVariant, IdealVariantTypes, ShopifyProduct} from '../../interfaces/shopify-product.interface';
import {ShoppingCartUtils} from '../../utils/shopping-cart_utils';
import { EventType } from '../../interfaces/shopping-cart.interface';

export class IdealService extends ApiService {
  productVariantsSubject: makeBehaviorSubject<object>;
  selectedProductSubject: makeBehaviorSubject<IdealVariant | null>;
  selectedVariantValueSubject: makeBehaviorSubject<string>;
  private product: ShopifyProduct = null;
  private readonly selectedProductOptions: Pick<IdealVariant, 'option1' | 'option2' | 'option3'>;

  constructor() {
    super();
    this.productVariantsSubject = makeBehaviorSubject(this.selectedProductOptions);
    this.selectedProductSubject = makeBehaviorSubject(null);
    this.selectedVariantValueSubject = makeBehaviorSubject('');
    this.selectedProductOptions = {option1: null, option2: null, option3: null};
  }

  updateProductVariant(variantName: string, variantValue: string) {
    this.selectedProductOptions[variantName] = variantValue;
    this.selectedVariantValueSubject(EventType.Data, variantValue);
    this.productVariantsSubject(EventType.Data, this.selectedProductOptions);
    this.getSelectedVariant();
  }

  updateProductData(product: ShopifyProduct) {
    this.product = product;
    this.getSelectedVariant();
  }

  private getSelectedVariant() {
    if (!this.product) {
      return;
    }
    let selectedVariant = this.product.variants.filter((variant: IdealVariant) => {
      return ShoppingCartUtils.isMatchingVariant(this.selectedProductOptions, variant) &&
        variant.variant_type !== IdealVariantTypes.MODEL;
    });

    if (!selectedVariant.length && this.selectedProductOptions.option1) {
      selectedVariant = this.product.variants
        .filter(variant => variant.option1 === this.selectedProductOptions.option1);
    }

    if (!selectedVariant.length) {
      selectedVariant = [{...this.product.variants[0], isAutoSelected: true} as IdealVariant];
    }
    // this property is needed to save original value of available amount
    // (used in the shopping cart) similar to shopify approach
    selectedVariant[0].inventory_quantity = selectedVariant[0].quantity;

    this.selectedProductSubject(EventType.Data, selectedVariant[0]);
  }
}
